import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { v_DispatchBus } from '../../shared/models/v_DispatchBus';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { v_DispatchAttachmentDetailBus } from '../../shared/models/v_DispatchAttachmentDetailBus';

@Component({
  selector: 'dispatch-photos',
  templateUrl: './dispatch-photos.component.html',
  styleUrls: ['./dispatch-photos.component.scss']
})
export class DispatchPhotosComponent implements OnInit {
  constructor(private svc_data: DispatchesService) {

  }

  @Input()
  data: v_DispatchAttachmentDetailBus[];

  dataItem: v_DispatchAttachmentDetailBus;

  dataLoading: boolean = false;
//  gridData: v_DispatchBus[];
  ngOnInit() {
  }

  //view(data: v_DispatchAttachmentBus) {

  //}
  hide() {
    this.selectedImage = null;
  }
  selectedImage: any;
  selected: boolean = false;
  setSelectedImage(image) {
    this.selectedImage = image;
  }
}

